import { Link } from 'react-router-dom';

export const ProductCard = ({ product }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);
  };

  return (
    <Link 
      to={`/product/${product.id}`}
      className="group block border border-border hover:border-primary transition-colors"
      data-testid={`product-card-${product.id}`}
    >
      <div className="product-image-container aspect-square bg-black">
        <img 
          src={product.image_url} 
          alt={product.name}
          className="w-full h-full object-contain"
          loading="lazy"
        />
      </div>
      <div className="p-4 border-t border-border">
        <h3 
          className="font-bold text-sm uppercase tracking-wide group-hover:text-primary transition-colors"
          style={{ fontFamily: "'Oswald', sans-serif" }}
        >
          {product.name}
        </h3>
        <p className="text-muted-foreground text-xs uppercase tracking-wider mt-1">
          {product.subcategory}
        </p>
        <p className="font-bold mt-2" data-testid={`product-price-${product.id}`}>
          {formatPrice(product.price)}
        </p>
      </div>
    </Link>
  );
};
